<template>
  <div
    v-if="showTooltip"
    data-png-ignore
    class="icon-container"
    :class="{
      'full-width-activator': fullWidthActivator,
      [tooltip.key]: true,
    }"
  >
    <DpplEnhancedTooltip
      :position="tooltipDirection"
      :max-width="maxWidth"
    >
      <template #activator>
        <v-icon
          :color="iconColor"
          size="18px"
          :icon="icon"
        />
      </template>
      <div class="content">
        <strong v-if="tooltip.title">{{ tooltip.title }}<br></strong>
        <div>
          <DpplSafeHtml :html="html" />
        </div>
      </div>
    </DpplEnhancedTooltip>
  </div>
</template>

<script>
import DpplEnhancedTooltip from '@/components/datapeople/DpplEnhancedTooltip.vue';
import DpplSafeHtml from '@ui/components/general/DpplSafeHtml/DpplSafeHtml.vue';

export default {
  name: 'InsightsTooltip',
  components: {
    DpplEnhancedTooltip,
    DpplSafeHtml,
  },
  props: {
    tooltip: {
      type: Object,
      default() {
        return {};
      },
    },
    icon: {
      type: String,
      default: '$information-outline',
    },
    iconColor: {
      type: String,
      default: 'iconDefault',
    },
    fullWidthActivator: {
      type: Boolean,
      default: false,
    },
    tooltipDirection: {
      type: String,
      default: 'start',
    },
    maxWidth: {
      type: String,
      default: '208px',
    },
  },
  computed: {
    html() {
      if (!this.tooltip?.html) return '';

      return this.tooltip.html.endsWith('\n') ? this.tooltip.html.slice(0, -2) : this.tooltip.html;
    },
    showTooltip() {
      const { tooltip } = this;

      return Boolean(tooltip.html);
    },
  },
};
</script>

<style lang="less" scoped>
.datapeople-app .icon-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &.full-width-activator {
    width: 100%;
  }

  :deep(.datapeople-tooltip).v-overlay__content {
    width: v-bind(maxWidth);
    max-width: v-bind(maxWidth) !important;
    pointer-events: auto;

    span, p, strong {
      font-size: 14px;
      line-height: 16px;
    }
  }
}

.content {
  white-space: pre-line;

  :deep(span), :deep(p), :deep(strong), :deep(div) {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    font-weight: 300;
  }

  :deep(strong) {
    font-weight: 400;
  }
}
</style>
